import { useEffect, useState } from 'react';
import Experiments from '@wix/fe-essentials/experiments';
export function useModalExperiments(experimentsConfig) {
    var _a = useState(), experimentsBag = _a[0], setExperimentsBag = _a[1];
    useEffect(function () {
        if (!experimentsConfig) {
            return;
        }
        var experiments = new Experiments({
            scopes: experimentsConfig.scopes,
            useNewApi: true,
        });
        experiments.ready().then(function () {
            var _a;
            var searchParams = new URLSearchParams(location.href);
            var petriOvr = searchParams.get('petri_ovr');
            if (petriOvr) {
                for (var _i = 0, _b = petriOvr.split(';'); _i < _b.length; _i++) {
                    var override = _b[_i];
                    var _c = override.split(':'), name_1 = _c[0], value = _c[1];
                    experiments.add((_a = {},
                        _a[name_1] = value,
                        _a));
                }
            }
            setExperimentsBag(experiments.all());
        });
    }, [experimentsConfig]);
    return experimentsBag;
}
//# sourceMappingURL=useModalExperiments.js.map